import { Injectable } from '@angular/core';

/*
  Generated class for the ConstantsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConstantsProvider {

   public pdfAddressEn = "15/F, Regent Centre, 88 Queen's Road, Central, Hong Kong";
   public pdfAddressZh = "中環皇后大道中 88 號勵精中心 15 樓";
   public pdfTel = "2525 9288 / 2525 9919";
   public pdfFax = "2525 6168";
   public pdfUrl = "www.chains.hk";

   public tempData = {};


   public physicians = [];
   public isAdmin = true;
   public selectedTicket: any = {};
   public selectedPatient = {};
   public selectedMedicals = {};

   public isEdit = false;

   public history = [];
   public dispRestrictionRules = {};

   /** ----- Constructors ----- **/

   constructor() { }


   /** ----- Public Methods ----- **/

   findPhysicianName(inId) {
      for (let i = 0; i < this.physicians.length; i++) {
         // if ID found
         if (this.physicians[i]['phy_id'] == inId) {
            return this.physicians[i]['phy_name_zh'];
         }
      }
      // return this.accountInfo[ "phy_name_zh" ];
      return '-';

   }


   findPdfPhysicianName(inId) {

      for (let i = 0; i < this.physicians.length; i++) {

         // if ID found
         if (this.physicians[i]['phy_id'] == inId) {

            return this.physicians[i]['phy_name_en'];

         }

      }

      return '-';

   }


   findPdfPhysicianTitle(inId) {

      for (let i = 0; i < this.physicians.length; i++) {

         // if ID found
         if (this.physicians[i]['phy_id'] == inId) {

            return this.physicians[i]['phy_title_en'];

         }

      }

      return '-';

   }


   findPdfPhysicianRegNo(inId) {

      for (let i = 0; i < this.physicians.length; i++) {

         // if ID found
         if (this.physicians[i]['phy_id'] == inId) {

            return this.physicians[i]['phy_reg_no'];

         }

      }

      return '-';

   }

}



// WEBPACK FOOTER //
// ./src/providers/constants/constants.ts